module.exports = __webpack_public_path__ + "static/img/H21.3b2666d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/H21.png
// module id = 9+RN
// module chunks = 0